import { types, getParent, flow } from 'mobx-state-tree';
import { BillingCodeRow } from './models';
import { resolvePaginationStore } from '../PaginationStore';

const BillingCodesStore = types
  .model('BillingCodesStore', {
    billingCodes: types.array(BillingCodeRow),
    pagination: types.optional(
      resolvePaginationStore({
        onChangePerPage: (self) => getParent(self).loadBillingCodes(),
        onChangePage: (self, page) => getParent(self).loadBillingCodes({ page }),
      }),
      {
        perPage: 50
      },
    ),
  })
  .volatile(self => ({
    loading: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    loadBillingCodes: flow(function* ({ page = 1 } = {}) {
      try {
        self.loading = true;
        const response = yield self.root.api.billingCode.index({ page: page, per_page: self.pagination.perPage });
        self.billingCodes = response.data.data;
        self.pagination.setFromMeta(response.data.meta);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    destroy: flow(function* (id) {
      let response;
      if (window.confirm('Are you sure to delete it?')) {
        try {
          self.loading = true;
          response = yield self.root.api.billingCode.destroy(id);
          self.loadBillingCodes();
        } catch (error) {
          self.root.ui.toast.error(error);
        }
        self.loading = false;
      }
    }),
  }))


export default BillingCodesStore;
